import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import AttachmentFactory from "../../Entity/Factories/AttachmentFactory";

export default function* attachmentList(action: ActionInterface): any {
  try {
    let request = "attachments?";

    typeof action.payload?.financialStatementId !== "undefined" ?
            request += `&financial_statement_id=${action.payload?.financialStatementId}` : request;

    typeof action.payload?.contractId !== "undefined" ?
            request += `&contract_id=${action.payload?.contractId}` : request;

    typeof action.payload?.type !== "undefined" ?
            request += `&type=${action.payload?.type}` : request;

    typeof action.payload?.language !== "undefined" ?
            request += `&lng=${action.payload?.language}` : request;
    const res = yield call(Http.get, request);

    const attachments = res.data.data.map(attachment => {
      return AttachmentFactory.create(attachment);
    });

    yield put({
      type: Constants.GLOBAL_ATTACHMENT_LIST_SUCCESS,
      payload: {
        attachments: attachments
      }
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, attachments);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);
  }
}

export function* watchAttachmentList() {
  yield takeEvery(Constants.GLOBAL_ATTACHMENT_LIST, attachmentList);
}
